import type { MetaDescriptor } from 'react-router';
import {
    handle as publicHandle,
    loader,
    default as ProfessionalProductsRoute,
} from '~/routes/_app.professional.$urlSegment.our-products.$';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import { mergeMeta } from '~/modules/seo';
import type { APHandle } from '~/modules/root';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    () => {
        const preloadImageLinks: MetaDescriptor[] = [];
        return [...preloadImageLinks];
    },
);

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

export const handle: APHandle = {
    ...publicHandle,
    disabledInPreview,
};

export { loader };
export default ProfessionalProductsRoute;
